import { render } from "./BaseIconButton.vue?vue&type=template&id=478af013&scoped=true"
import script from "./BaseIconButton.vue?vue&type=script&lang=js"
export * from "./BaseIconButton.vue?vue&type=script&lang=js"

import "./BaseIconButton.vue?vue&type=style&index=0&id=478af013&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478af013"]])

export default __exports__